var klaviyo = klaviyo || [];

klaviyo.init({
  account: "MFzLUb",
  platform: "shopify"
});

klaviyo.enable("backinstock",{ 
  trigger: {
    product_page_text: "Notify Me When Available",
    product_page_class: "button product-form__add-button w3-add-to-cart button--primary bis-button",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false
  },
  modal: {
    headline: "{product_name}",
    body_content: "Register to receive a notification when this item comes back in stock.",
    email_field_label: "Email",
    button_label: "Notify me when available",
    subscription_success_label: "You're in! We'll let you know when it's back.",
    footer_content: '',
    additional_styles: '@font-face{font-family:AT Name Sans;src:url("https://cdn.shopify.com/s/files/1/1791/0383/files/AT-NameSansVariable-Upright.woff2?v=1738352263");font-weight:1 900;font-style:normal}.form-control{border-radius:4px}select.form-control{margin:0;width:100%;font-family:inherit;font-size:inherit;cursor:inherit;line-height:inherit;appearance:none}select.form-control::after{content:"";width:.8em;height:.5em;background-color:#fff;clip-path:polygon(100% 0%,0 0%,50% 100%)}',
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#000",
    button_text_color: "#fff",
    button_background_color: "rgb(0,87,255)",
    close_button_color: "#ccc",
    error_background_color: "rgb(255, 214, 191)",
    error_text_color: "#000",
    success_background_color: "rgb(207, 231, 208)",
    success_text_color: "#000",
    font_family: 'AT Name Sans',
    font_family_heading: 'AT Name Sans',
  }
});
